import React from "react";
import NavBar from "../../molecules/NavBar/NavBar";
import Button from "../../atoms/Button/Button";
import LogoBigger from "../../../static/logo_bigger.svg";
import { getSignupUrl } from "../../../constants/urls";

const Banner = () => {
  const handleRedirectToApp = () => {
    window.location.href = getSignupUrl();
  };

  return (
    <div className="dui-banner-container" id="banner">
      <NavBar />
      <div className="dui-banner-content">
        <div className="dui-banner-logo-wrapper">
          <img
            src={LogoBigger}
            alt="DoktorUI Logo"
            className="dui-banner-logo"
          />
        </div>
        <h1 className="dui-banner-heading">
          <span className="dui-banner-top-heading">
            Krok vpred k{" "}
            <span className="dui-banner-heading-higlight">rýchlejším</span>
          </span>
          <br />
          <span className="dui-banner-bottom-heading">
            <span className="dui-banner-heading-higlight">
              lekárskym správam
            </span>
          </span>
        </h1>
        <p className="dui-banner-paragraph">
          <span className="dui-banner-paragraph-top-line">
            Náš softvér zjednodušuje písanie dekurzov, šetrí čas
            <br className="mobile-hidden" /> a dáva viac priestoru pacientom.
          </span>
        </p>
        <Button
          className="dui-banner-button"
          corners="rounded"
          onClick={handleRedirectToApp}
        >
          Vyskúšať
        </Button>
      </div>
    </div>
  );
};

export default Banner;
